module.exports = __webpack_public_path__ + "media/img/prod-2-d2e72e37.jpg";